import { Injectable } from '@angular/core';

import { Categoria } from '../domain/categorias';
import { Sede } from '../domain/sedes';
import { Area } from '../domain/areas';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {SubCategoria} from '../domain/subCategorias';
import {List} from '../domain/List';
import {Ticket} from '../domain/tickets';
import {Estado} from '../domain/estado';
import {User} from '../domain/User';
import {AllTickets} from '../domain/AllTickets';
import {Usuario} from '../domain/usuario';
import { Option } from './../domain/select/option';

@Injectable()
export class FormService {

    constructor(private http: HttpClient) { }
    urlArea = '/api/areas';
    urlSede = '/api/sedes/';
    urlCategoria = '/api/categoria';
    urlSubCategoria = '/api/subcategoria/';
    urlSistemasPropios = '/api/sistemas_propios/';
    urlPedido = '/api/pedido';
    urlTicket = '/api/ticket';
    urlTickets = this.urlTicket + 's/';
    urlExecutorTickets = this.urlTickets + 'executor/';
    urlMail = '/api/mailTicketGenerado/';
    urlMailFinTicket = '/api/mailFinTicket';
    urlMailReabiertoTicket = '/api/mailReabiertoTicket';
    urlEstado = '/api/estado';
    urlEstadoIngresados = '/api/estado/ingresados';
    urlEstadoAsignados = '/api/estado/asignados';
    urlEstadoFinalizados = '/api/estado/finalizados';
    urlEstadoReAbierto = '/api/estado/reabierto';
    urlObservacion = 'api/observacion';
    urlExecutors = 'api/executors';
    urlAsignExecutor = this.urlExecutors + '/asign';
    urlDesasignExecutor = this.urlExecutors + '/unnasigned';
    urlView = '/api/views';
    urlTicketsNuevos = this.urlTickets + 'nuevos';
    urlTicketsIngresados = this.urlTickets + 'ingresados';
    urlTicketsAsignados = this.urlTickets + 'asignados';
    urlTicketsReabiertos = this.urlTickets + 'reabiertos';
    urlTicketsFinalizados = this.urlTickets + 'finalizados';
    urlExecutorsActivos = this.urlExecutorTickets + 'activos/';
    urlExecutorsReabiertos = this.urlExecutorTickets + 'reabiertos/';
    urlExecutorsFinalizados = this.urlExecutorTickets + 'finalizados/';
    urlCombos = 'api/combos';
    urlObservacionYCombos = 'api/observacionYCombos';

    urlDependencias = 'api/dependencias';
    urlPerfilxSistema = 'api/sistemas/perfiles/';
    urlSistemasGestionUsuario = 'api/sistemas/gestionusuario';


    // inicio solicitudInformacion

    urlFormFisico = 'solicitudInformacion/form/fisico';
    urlFormJuridico = 'solicitudInformacion/form/juridico';
    urlTemas = 'solicitudInformacion/temas';
    urlTipoDocumento = 'solicitudInformacion/tipoDocumentos';

    setSolicitudInformacionFisico(data): Observable<boolean>{
        return this.http.post<boolean>(this.urlFormFisico, data);
    }

    setSolicitudInformacionJuridico(data): Observable<boolean>{
        return this.http.post<boolean>(this.urlFormJuridico, data);
    }

    getTemas(): Observable<Option> {
        return this.http.get<Option>(this.urlTemas);
    }

    getTipoDocumentos(): Observable<Option> {
        return this.http.get<Option>(this.urlTipoDocumento);
    }


    // fin solicitudInformacion

    getSistemasGestionUsuarios(): Observable<Option> {
        return this.http.get<Option>(this.urlSistemasGestionUsuario);
    }

    setGestionUsuario(data): Observable<boolean>{
        return this.http.post<boolean>(this.urlSistemasGestionUsuario, data);
    }

    getDependenciasGestionUsuarios(): Observable<Option> {
        return this.http.get<Option>(this.urlDependencias);
    }

    getPerfilesXSistema(idSistema): Observable<Option> {
        return this.http.get<Option>(this.urlPerfilxSistema+idSistema);
    }




    getDataAreas(): Observable<List> {
        return this.http.get<List>(this.urlArea);
    }

    getDataCategoria(): Observable<List> {
        return this.http.get<List>(this.urlCategoria);
    }

    getDataSubCategoria(id): Observable<List> {
        const url = this.urlSubCategoria + id;
        return this.http.get<List>(url);
    }

    getSistemasPropios(): Observable<any> {
        return this.http.get<any>(this.urlSistemasPropios);
    }


    getDataSedes(id): Observable<List> {
        const url = this.urlSede + id;
        return this.http.get<List>(url);
    }
    guardarPedido(data) {
        return this.http.post(this.urlPedido, data);
    }
    getTicket(id): Observable<Ticket> {
        const url = this.urlTicket + '/' + id;
        return this.http.get<Ticket>(url);
    }
    getTicketsUser(id): Observable<AllTickets[]> {
        const url = this.urlTickets + id;
        return this.http.get<AllTickets[]>(url);
    }
    getTicketsUser2(id): Observable<Ticket[]> {
        const url = this.urlTickets + id;
        return this.http.get<Ticket[]>(url);
    }
    enviarMail(id) {
        return this.http.get(this.urlMail + id);
    }
    updateObservacion(data) {
        return this.http.post(this.urlObservacion, data);
    }
    updateObservacionYCombos(data) {
        return this.http.post(this.urlObservacionYCombos, data);
    }
    mailFinDeTicket(data){
        return this.http.post(this.urlMailFinTicket, data);
    }
    mailReabierto(data){
        return this.http.post(this.urlMailReabiertoTicket, data);
    }
    getEstados(): Observable<Estado[]> {
        return this.http.get<Estado[]>(this.urlEstado);
    }
    getEstadosIngresados(): Observable<Estado[]> {
        return this.http.get<Estado[]>(this.urlEstadoIngresados);
    }
    getEstadosAsignados(): Observable<Estado[]> {
        return this.http.get<Estado[]>(this.urlEstadoAsignados);
    }
    getEstadosReabierto(): Observable<Estado[]> {
        return this.http.get<Estado[]>(this.urlEstadoReAbierto);
    }
    getEstadosFinalizados(): Observable<Estado[]> {
        return this.http.get<Estado[]>(this.urlEstadoFinalizados);
    }
    updateEstado(data) {
        return this.http.post(this.urlEstado, data);
    }
    updateCombos(data) {
        return this.http.post(this.urlCombos, data);
    }
    getAllTickets(): Observable<AllTickets[]> {
        return this.http.get<AllTickets[]>(this.urlTickets);
    }
    getAllTicketsNuevos(): Observable<AllTickets[]> {
        return this.http.get<AllTickets[]>(this.urlTicketsNuevos);
    }
    getAllTicketsIngresados(): Observable<AllTickets[]> {
        return this.http.get<AllTickets[]>(this.urlTicketsIngresados);
    }
    getAllTicketsAsignados(): Observable<AllTickets[]> {
        return this.http.get<AllTickets[]>(this.urlTicketsAsignados);
    }
    getAllTicketsReabiertos(): Observable<AllTickets[]> {
        return this.http.get<AllTickets[]>(this.urlTicketsReabiertos);
    }
    getAllTicketsFinalizados(): Observable<AllTickets[]> {
        return this.http.get<AllTickets[]>(this.urlTicketsFinalizados);
    }
    getAllTickets2(): Observable<Ticket[]> {
        return this.http.get<Ticket[]>(this.urlTickets);
    }
    getExecutorTickets(id): Observable<AllTickets[]> {
        const url = this.urlExecutorTickets + id;
        return this.http.get<AllTickets[]>(url);
    }
    getExecutorTicketsActivos(id): Observable<AllTickets[]> {
        const url = this.urlExecutorsActivos + id;
        return this.http.get<AllTickets[]>(url);
    }
    getExecutorTicketsReAbiertos(id): Observable<AllTickets[]> {
        const url = this.urlExecutorsReabiertos + id;
        return this.http.get<AllTickets[]>(url);
    }
    getExecutorTicketsFinalizados(id): Observable<AllTickets[]> {
        const url = this.urlExecutorsFinalizados + id;
        return this.http.get<AllTickets[]>(url);
    }
    getExecutors(): Observable<Usuario[]> {
        return this.http.get<AllTickets[]>(this.urlExecutors);
    }
    asignarEjecutor(data) {
        return this.http.post(this.urlAsignExecutor, data);
    }
    DesasignarEjecutor(data) {
        return this.http.post(this.urlDesasignExecutor, data);
    }
    setViews(data){
        return this.http.post(this.urlView, data);
    }



}



// WEBPACK FOOTER //
// ./src/app/shared/services/formServices.ts